var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"back-top"},[_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('body'),expression:"'body'"}]},[_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":"icon_top","width":16,"height":16}}),_c('div',[_vm._v("TOP")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }